import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const popover: SxStyle = {};

export const popoverContent: SxStyle = {};
